export default __webpack_public_path__ + "static/media/workspace.0b6ae72e.md";